module.exports = __webpack_public_path__ + "static/gm-34-4cb447bd98a4533df0da05ef4dc05b7f.jpg";